/* Storewide: add-to-cart keeps Subscribe & Save. Seal/theme must not drop selling_plan. */
(function () {
  if (window.__nrSubscribeCartBound) return;
  window.__nrSubscribeCartBound = true;

  function parseId(v) {
    var n = parseInt(v, 10);
    return n > 0 ? n : 0;
  }

  function formAction(form) {
    return String(form.getAttribute('action') || form.action || '');
  }

  function isCartAdd(form) {
    /* Wholesale Order Products (/collections/all) has its own AJAX handler in
       free-life-shop.js and must stay on the page — never redirect to /cart. */
    if (form.hasAttribute('data-fls-form') || form.closest('[data-fls-root]')) return false;
    var a = formAction(form);
    if (a.indexOf('/cart/add') !== -1) return true;
    if (form.getAttribute('data-type') === 'add-to-cart-form') return true;
    if (form.querySelector('[data-nr-subscribe], [data-nr-selling-plan]')) return true;
    return false;
  }

  function selectedRow(form) {
    return form.querySelector('[data-nr-size].is-on') || form.querySelector('[data-nr-size]');
  }

  function variantId(form) {
    var row = selectedRow(form);
    if (row && row.dataset.variantId) return parseId(row.dataset.variantId);
    var el = form.querySelector('[data-nr-variant-id], input[name="id"]');
    return el ? parseId(el.value || el.getAttribute('value')) : 0;
  }

  function sellingPlanId(form) {
    var sub = form.querySelector('[data-nr-subscribe]');
    var row = selectedRow(form);
    var fromRow = row ? parseId(row.dataset.sellingPlan) : 0;
    if (sub) return sub.checked ? fromRow : 0;

    var named = form.querySelectorAll('input[name="selling_plan"], select[name="selling_plan"]');
    for (var i = 0; i < named.length; i++) {
      var el = named[i];
      if (el.disabled) continue;
      if (el.type === 'radio' || el.type === 'checkbox') {
        if (!el.checked) continue;
      }
      var n = parseId(el.value);
      if (n) return n;
    }

    var seal = form.querySelector(
      '.sealsubs-container input:checked, .sealsubs-subscribe-now input:checked, [data-selling-plan-id]:checked'
    );
    if (seal) return parseId(seal.value || seal.getAttribute('data-selling-plan-id'));
    return 0;
  }

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || form.nodeName !== 'FORM') return;
      if (form.getAttribute('data-nr-native-submit') === '1') return;
      if (!isCartAdd(form)) return;
      var vid = variantId(form);
      if (!vid) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      var qtyEl = form.querySelector('[data-nr-qty], input[name="quantity"]');
      var qty = Math.max(1, parseId(qtyEl && qtyEl.value) || 1);
      var item = { id: vid, quantity: qty };
      var plan = sellingPlanId(form);
      if (plan) item.selling_plan = plan;

      var items = [item];
      var extra = form.querySelector('[data-nr-capsules]:checked, [data-nr-cream]:checked, [data-nr-gel]:checked');
      if (extra && extra.value) {
        var xid = parseId(extra.value);
        if (xid) items.push({ id: xid, quantity: 1 });
      }

      var atc = form.querySelector('[data-nr-atc], button[type="submit"], button.product-form__submit');
      var prev = atc ? atc.innerHTML : '';
      if (atc) {
        atc.disabled = true;
        atc.textContent = 'Adding…';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('cart');
          window.location.href = '/cart';
        })
        .catch(function () {
          if (atc) {
            atc.disabled = false;
            atc.innerHTML = prev;
          }
          var planInput = form.querySelector('[data-nr-selling-plan], input[name="selling_plan"]');
          if (planInput) {
            if (plan) {
              planInput.disabled = false;
              planInput.value = String(plan);
            } else if (planInput.hasAttribute('data-nr-selling-plan')) {
              planInput.disabled = true;
            }
          }
          form.setAttribute('data-nr-native-submit', '1');
          HTMLFormElement.prototype.submit.call(form);
        });
    },
    true
  );
})();
